import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { loginUser } from '@/services/authApi';
import { getUserFriendlyMessage } from '@/services/apiError';
import FormMessage from '@/components/common/FormMessage';

export default function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const canSubmit = Boolean(formData.email.trim()) && Boolean(formData.password.trim()) && !loading;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) {
      return;
    }

    setError('');
    setLoading(true);

    try {
      const response = await loginUser({
        email: formData.email.trim(),
        password: formData.password,
      });
      login(response.token, response.user);
      navigate('/dashboard');
    } catch (error: unknown) {
      setError(getUserFriendlyMessage(error, '登录失败，请检查邮箱和密码'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-[calc(100vh-48px)] flex items-center justify-center px-4 py-16'>
      <div className='w-full max-w-[380px]'>
        <h1
          className='font-semibold text-apple-near-black mb-2'
          style={{ fontSize: '2rem', lineHeight: 1.1, letterSpacing: '-0.02em' }}
        >
          登录
        </h1>
        <p className='text-apple-gray mb-8' style={{ fontSize: '0.9375rem' }}>
          还没有账号？{' '}
          <Link to='/register' className='text-apple-blue-link hover:underline'>
            注册
          </Link>
        </p>

        <form className='space-y-5' onSubmit={handleSubmit}>
          {error ? <FormMessage tone='error' message={error} /> : null}

          <div className='space-y-1.5'>
            <label htmlFor='email' className='block text-[0.875rem] font-medium text-apple-near-black'>
              邮箱
            </label>
            <input
              id='email'
              type='email'
              required
              autoComplete='email'
              className='input'
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>

          <div className='space-y-1.5'>
            <label htmlFor='password' className='block text-[0.875rem] font-medium text-apple-near-black'>
              密码
            </label>
            <input
              id='password'
              type='password'
              required
              autoComplete='current-password'
              className='input'
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            />
          </div>

          <button
            type='submit'
            className='btn btn-primary w-full mt-2'
            disabled={!canSubmit}
          >
            {loading ? '登录中…' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
}